import React, { useState } from 'react';
import { useNavigate, Link, useLocation } from 'react-router-dom';
import '../styles/Contact.css';
import logo from '../assets/logo3.webp'; // Make sure this path is correct
import travel from '../assets/travel.png';

const ContactUs = () => {
  const [showPopup, setShowPopup] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();

    const form = e.target;
    const formData = new FormData(form);

    try {
      await fetch('https://formsubmit.co/info@travelkariye.com', {
        method: 'POST',
        body: formData,
      });

      setShowPopup(true);
      setTimeout(() => {
        setShowPopup(false);
        navigate('/');
      }, 2000);
    } catch (error) {
      console.error('Submission failed:', error);
    }
  };
    const location = useLocation();

  return (
    <>
      {/* Header Section */}
      <header className="contact-header over-banner">
        <div className="contact-logo">
          <img src={logo} alt="Tourly Logo" />
        </div>
        <nav className="contact-nav">
          <Link to="/">Home</Link>
          <Link to="/packages">Packages</Link>
          <div className="contact-dropdown">
            <a href="#" className="contact-dropbtn">Destinations</a>
  
<div className="contact-dropdown-content">
              <Link to="/goa">Goa</Link>
              <Link to="/kerala">Kerala</Link>
              <Link to="/rajasthan">Rajasthan</Link>
              <Link to="/himachal">Himachal Pradesh</Link>
              <Link to="/uttarakhand">Uttarakhand</Link>
                              <Link to="/abu">Abu Dhabi</Link>
                <Link to="/dubai">Dubai</Link>
            </div>
          </div>
            <Link to="/hotels">Hotels</Link>
        <Link to="/contact-us" className={location.pathname === '/contact-us' ? 'active-link' : ''}>Contact Us</Link>
          
        </nav>
          <Link to="/booknow">
        <button className="contact-book-btn">Book Now</button>
                                    </Link>
      </header>

      {/* Contact Form Section */}
      <div className="contact-wrapper">
        <div className="contact-card">
          <div className="form-section">
            <h2>Contact Us</h2>
            <p>We’d love to hear from you!</p>
            <form onSubmit={handleSubmit}>
              <input type="text" name="name" placeholder="Your Name" required />
              <input type="email" name="email" placeholder="Your Email" required />
              <input type="text" name="phone" placeholder="Your Phone Number" required />
              <textarea name="message" rows="5" placeholder="Your Message" required></textarea>
              <button type="submit">Send Message</button>
            </form>
          </div>

          <div className="info-section">
            <img src={travel} alt="Contact Banner" className="contact-image" />
          </div>
        </div>

        {showPopup && (
          <div className="popup-overlay">
            <div className="popup-box">
              <p>Thank you! Your message has been submitted.</p>
            </div>
          </div>
        )}
      </div>
    </>
  );
};

export default ContactUs;
